import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'radio']

  connect() {
    // Set initial state based on checked radio
    this.radioTargets.forEach((radio) => {
      if (radio.checked) {
        this.selectButton(radio.dataset.value)
      }
    })

    // Add click handlers to buttons
    this.buttonTargets.forEach((button) => {
      button.addEventListener('click', (event) => this.select(event))
    })
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    const radio = this.radioTargets.find((r) => r.dataset.value === value)
    if (radio) {
      radio.checked = true
      this.selectButton(value)
    }
  }

  selectButton(value) {
    this.buttonTargets.forEach((button) => {
      if (button.dataset.value === value) {
        button.classList.add('selected')
      } else {
        button.classList.remove('selected')
      }
    })
  }
}
